export enum StatsUnit {
  EURO = '€',
  KILOGRAM = 'Kg',
  METER = 'm',
  KILOMETER = 'Km',
  CUBIC_METER = 'm3',
  DAYS = 'J',
}
